import { render, staticRenderFns } from "./OnlCgreportHeadList.vue?vue&type=template&id=17c138cd&scoped=true&"
import script from "./OnlCgreportHeadList.vue?vue&type=script&lang=js&"
export * from "./OnlCgreportHeadList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgreportHeadList.vue?vue&type=style&index=0&id=17c138cd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c138cd",
  null
  
)

export default component.exports